import { useRef, useState } from "react";
import { toast } from "sonner";
import { History, Upload, Loader2 } from "lucide-react";
import { api, coachHeaders, formatDateHeure } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const RestoreDialog = ({ code, cible, onClose, onDone }) => {
  const [mot, setMot] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const headers = coachHeaders(code);
      const r = cible.file
        ? await api.post("/admin/restaurer-fichier", await cible.file.arrayBuffer(), { headers: { ...headers.headers, "Content-Type": "application/octet-stream" } })
        : await api.post(`/admin/sauvegardes/${cible.nom}/restaurer`, {}, headers);
      toast.success(`Données restaurées (${r.data?.joueurs ?? 0} joueurs). L'état précédent a été sauvegardé.`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Restauration impossible"); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o && !busy) onClose(); }}>
      <DialogContent data-testid="restore-dialog" className="w-[calc(100%-1.5rem)] max-w-md rounded-[24px] border-signal bg-pitch text-chalk">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl uppercase text-signal"><History className="h-6 w-6" />Restaurer</DialogTitle>
          <DialogDescription className="text-chalk">
            Toutes les données actuelles (joueurs, encadrement, convocations, réponses, archives, réglages et codes d'accès) seront remplacées par celles de : <strong>{cible.file ? cible.file.name : formatDateHeure(cible.date)}</strong>.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-dim">Une sauvegarde de l'état actuel est faite juste avant, pour pouvoir revenir en arrière. Tape <strong className="text-chalk">RESTAURER</strong> pour confirmer.</p>
        <input data-testid="restore-confirm-input" value={mot} onChange={(e) => setMot(e.target.value)} autoCapitalize="characters" placeholder="RESTAURER"
          className="w-full rounded-xl border border-line bg-ink px-3 py-2 font-mono text-chalk outline-none focus:border-signal" />
        <div className="flex justify-end gap-2">
          <button data-testid="restore-cancel" onClick={onClose} disabled={busy} className="rounded-full border border-line px-5 py-2 text-sm">Annuler</button>
          <button data-testid="restore-confirm-button" onClick={go} disabled={busy || mot.trim().toUpperCase() !== "RESTAURER"}
            className="inline-flex items-center gap-2 rounded-full bg-signal px-5 py-2 text-sm font-semibold text-ink disabled:opacity-40">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Restaurer
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const RestoreFromFile = ({ onPick }) => {
  const ref = useRef(null);
  return (
    <>
      <input ref={ref} data-testid="restore-file-input" type="file" accept=".gz,.json,application/gzip,application/json" className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) onPick({ file: f }); e.target.value = ""; }} />
      <button data-testid="restore-file-button" onClick={() => ref.current?.click()}
        className="inline-flex items-center gap-2 rounded-full border border-signal px-5 py-2.5 text-sm font-semibold text-signal transition-colors hover:bg-signal hover:text-ink">
        <Upload className="h-4 w-4" />Restaurer depuis un fichier
      </button>
    </>
  );
};
